import { useRoute } from 'vue-router'

export const useRouteId = () => {
  const route = useRoute()

  return route.params.id as string | undefined
}